import React, { ReactElement, useState } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { Divider } from '../Divider';
import { NoStyleButton } from '../helpers/NoStyleButton';
import { Icon } from '../Icon';
type AccordionSize = Extract<SizesType, 'sm' | 'lg' | 'xl'>;
interface AccordionProps {
  /** The content rendered inside the open Accordion */
  children: React.ReactNode;
  /** Pass through className to allow styles overrides */
  className?: string;
  /** The header or title that is always on display */
  header?: ReactElement | string;
  /** Whether the accordion will start collapsed or not */
  isOpenByDefault?: boolean;
  /** Callback invoked whenever the collapsed state changes */
  onToggle?: (state: boolean) => void;
  /** Any React component can be used as an icon */
  icon?: React.ReactNode;
  /** If set, accordion trigger will be rendered under the collapsible content */
  isBottomAligned?: boolean;
  /** The size of the accordion header */
  size?: AccordionSize;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether to show divider on the bottom of Accordion */
  withDivider?: boolean;
  /** Whether to show header side padding*/
  hasSidePadding?: boolean;
}
const TabElement = /*#__PURE__*/styled('div')({
  name: "TabElement",
  class: "txs0sdz",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => NoStyleButton;
export const Header = /*#__PURE__*/styled(_exp2())({
  name: "Header",
  class: "h1hn7b",
  propsAsIs: true
});
export const Content = /*#__PURE__*/styled('div')({
  name: "Content",
  class: "cgqd9l7",
  propsAsIs: false
});
export const HeaderText = /*#__PURE__*/styled('span')({
  name: "HeaderText",
  class: "h1szeab9",
  propsAsIs: false
});
export const ArrowElementWrapper = /*#__PURE__*/styled('div')({
  name: "ArrowElementWrapper",
  class: "a1f9et4",
  propsAsIs: false
});
export const Accordion = ({
  header = '',
  isOpenByDefault = false,
  children,
  className,
  onToggle,
  isBottomAligned = false,
  size = 'lg',
  icon,
  dataId,
  withDivider = false,
  hasSidePadding = false
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const handleOnOpen = () => {
    setIsOpen(!isOpen);
    if (onToggle) onToggle(!isOpen);
  };
  return <>
      <TabElement data-id={dataId} className={cx(className, isBottomAligned && '--bottom-aligned', hasSidePadding && '--sidePadding')}>
        <Header className={`--size-${size}`} onClick={handleOnOpen} type="button">
          {icon && <div>{icon}</div>}
          <HeaderText className={`--size-${size}`}>{header}</HeaderText>
          <ArrowElementWrapper className={cx(isOpen && '--open')}>
            <Icon name="ChevronUp" colorPath="content.neutral.c600" size="md" />
          </ArrowElementWrapper>
        </Header>
        <Content className={cx(!isOpen && '--hidden')}>{children}</Content>
      </TabElement>
      {withDivider && <Divider />}
    </>;
};

require("./Accordion.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Accordion.tsx");